<template>
  <div class="alert alert-warning text-left" role="alert">
    <p>
      The following users in your enrollment queue are no longer eligible for
      enrollment or have already been enrolled in the selected course.
    </p>
    <ul>
      <li v-for="(r, i) in removed" :key="i">
        {{ title(r) }} - {{ r.user.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    removed: { type: Array, required: true },
  },
  methods: {
    isCourse(enrollment) {
      return (
        !!enrollment.enrollable_type &&
        enrollment.enrollable_type === "App\\Models\\Courses\\Course"
      );
    },
    isEvent(enrollment) {
      return (
        !!enrollment.enrollable_type &&
        enrollment.enrollable_type === "App\\Models\\Events\\Event"
      );
    },
    isLearningPath(enrollment) {
      return !!enrollment.learning_path_id;
    },
    title(enrollment) {
      if (this.isLearningPath(enrollment)) {
        return `${enrollment.learningPath.name} (Learning Path)`;
      } else if (this.isEvent(enrollment)) {
        return `${enrollment.enrollable.name} (${this.$moment(
          enrollment.enrollable.start_date
        ).format("MM/DD/YY")})`;
      } else {
        return `${enrollment.enrollable.name} (Online Course)`;
      }
    },
  },
};
</script>